export enum DeviceTypes {
  Thermostat = 'thermostat',
  HEHM = 'hehm'
}

export const DEFAULT_NO_RESULTS_MESSAGE = {
  noResultsHeadingText: 'No results found',
  noResultsDescriptionText: 'Be sure to follow instructions above'
}
